import { createContext, useContext } from 'react';
import { BrandMenuResponse } from '../../types/api/menu.types';

/**
 * Which of the brand's menus the Menu page is showing. Provided once by
 * `Menu.tsx`; every modal and section under it that calls a menu-level route
 * (new category, new schedule, import, clear, publish history, AI improve)
 * reads `menuId` from here and passes it as `?menuId=`.
 *
 * `menuId: null` means "the default menu": the list has not loaded, the
 * brand's multi-menu flag is off, or the backend does not know about several
 * menus yet. `menu` is null and `menus` empty then too. Routes called without a
 * `menuId` work on the default, so the page behaves exactly as before.
 */
export type SelectedMenu = {
  menuId: number | null;
  menu: BrandMenuResponse | null;
  menus: BrandMenuResponse[];
};

export const SelectedMenuContext = createContext<SelectedMenu>({
  menuId: null,
  menu: null,
  menus: [],
});

export const useSelectedMenu = () => useContext(SelectedMenuContext);
